<template>
  <div v-if="!item['bIsHeading']">
    <div v-if="item.oSubmenu_arr !== null && Array.isArray(item.oSubmenu_arr) && item.oSubmenu_arr.length > 0">
      <span @click="handleClick(item)" v-bind:class="{ active: item.active }" class="nav-link collapsed"
         v-b-toggle="'accordion' +removeWhitespaces(item.sName)">
        <div class="sb-nav-link-icon">
          <i v-if="item.sIcon" v-bind:class="item.sIcon ? item.sIcon : ''"></i>
        </div>
        {{ item.sName }}
        <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
      </span>
      <b-collapse :id="'accordion' + removeWhitespaces(item.sName)"
                  :accordion="'my-accordion-' + removeWhitespaces(item.sName)"
                  role="tabpanel">
        <div class="sb-sidenav-menu-nested">

          <SideMenuItem v-for="(sidemenuitem,idx) in item.oSubmenu_arr" :key="idx" :item="sidemenuitem"></SideMenuItem>
        </div>
      </b-collapse>
    </div>
    <div v-else>
      <span @click="handleClick(item)" v-bind:class="{ active: item.active }" class="nav-link">
        <div class="sb-nav-link-icon">
          <i v-if="item.sIcon" v-bind:class="item.sIcon ? item.sIcon : ''"></i>
        </div>
        {{ item.sName }}
      </span>
    </div>
  </div>

  <div v-else class="sb-sidenav-menu-heading">{{ item.sName }}</div>
</template>

<script>
  export default {
    name: 'SideMenuItem',
    methods: {
      removeWhitespaces (str) {
        return str.replace(/\s/g, '_')
      },
      handleClick (item) {
        if (item.sPath !== undefined && item.sPath && item.sPath !== '') {
          this.$router.push(item.sPath);
        }
      }
    },
    props: [
      'item'
    ]
  }
</script>

<style scoped>

</style>
